// package imports
import { QueryClient } from '@tanstack/react-query';
import { NextRouter } from 'next/router';

// local imports
import { conversationHistoryKeys } from './hooks/conversationHistoryhooks';

export const newConversation = (
  queryClient: QueryClient,
  router: NextRouter,
  reset: () => void,
) => {
  queryClient.invalidateQueries({
    queryKey: conversationHistoryKeys.conversationHistory(),
  });
  reset();
  // get the current path and remove any query parameters
  const currentPath = router.asPath.split('?')[0];
  router.push(`${currentPath}?cid=new`);
};
